export default class ChatParticipantDTO {
    constructor(json) {
        this.id = json['id'];
        this.conversationId = json['conversation-id'];
        this.userId = json['user-id'];
        this.sendbirdUserId = json['sendbird-user-id'];
        this.active = json['active'];
        this.dateCreated = json['date-created'];
        this.hasUnreadMessages = json['has-unread-messages'];
    }
}
